import React from "react";
import { elastic as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";

function Burger(props) {
  function handleClick(e, destination) {
    e.preventDefault();
    return <Link to={`/${destination}`} />;
  }

  return (
    <Menu className="block md:hidden lg:hidden">
      <a className="menu-item" href="/">
        Home
      </a>
      <a className="menu-item" href="/activities">
        Activities
      </a>
      <a className="menu-item" href="/about">
        About Us
      </a>
      <a className="menu-item" href="/committee">
        Committee
      </a>
      <a className="menu-item" href="/gallery">
        Gallery
      </a>
      <a className="menu-item" href="/contact">
        Contact Us
      </a>
    </Menu>
  );
}

export default Burger;
